import { Paragraph } from "@/components/ui-library/typography/Body"
import { BlokProps } from "@helpers/StoryblokHelpers"
import { PhoneLinkStoryblok } from "@storyblok-types"

export const PhoneLink = ({ blok }: BlokProps<PhoneLinkStoryblok>) => {
  return (
    <Paragraph size="small">
      {blok.label} <a href={`tel:${blok.phone_number}`}>{blok.phone_number}</a>
    </Paragraph>
  )
}

export default PhoneLink
